export const classConstants = {
    GETALL_REQUEST: 'CLASSES_GETALL_REQUEST',
    GETALL_SUCCESS: 'CLASSES_GETALL_SUCCESS',
    GETALL_FAILURE: 'CLASSES_GETALL_FAILURE',
  
    DELETE_REQUEST: 'CLASS_DELETE_REQUEST',
    DELETE_SUCCESS: 'CLASS_DELETE_SUCCESS',
    DELETE_FAILURE: 'CLASS_DELETE_FAILURE',

    CREATE_REQUEST: 'CLASS_CREATE_REQUEST',
    CREATE_SUCCESS: 'CLASS_CREATE_SUCCESS',
    CREATE_FAILURE: 'CLASS_CREATE_FAILURE',

    UPDATE_REQUEST: 'CLASS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'CLASS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'CLASS_UPDATE_FAILURE',
  };
  